/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconDownload12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDownload12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="m8.354 6.146-.708-.707L6.5 6.586V1h-1v5.586L4.354 5.439l-.708.707L6 8.5l2.354-2.354Z"
                fill="currentColor"
            />
            <path
                d="M4 10h4c.48 0 .79 0 1.026-.017.228-.015.315-.042.357-.06a1 1 0 0 0 .54-.54c.018-.042.045-.129.06-.357C10 8.79 10 8.48 10 8V5.5h1V8c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C9.398 11 8.932 11 8 11H4c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C1 9.398 1 8.932 1 8V5.5h1V8c0 .48 0 .79.017 1.026.015.228.042.315.06.357a1 1 0 0 0 .54.54c.042.018.129.045.357.06C3.21 10 3.52 10 4 10Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconDownload16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDownload16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="m11.139 8.195-.943-.943-1.529 1.529V1.333H7.334v7.448L5.805 7.252l-.942.943L8 11.333l3.138-3.138Z"
                fill="currentColor"
            />
            <path
                d="M5.334 13.333h5.333c.64 0 1.053 0 1.369-.022.304-.02.42-.056.475-.08.327-.135.586-.394.722-.72.022-.056.058-.172.079-.476.021-.316.022-.729.022-1.368V7.333h1.333v3.334c0 1.242 0 1.863-.203 2.353a2.667 2.667 0 0 1-1.443 1.444c-.49.203-1.111.203-2.354.203H5.334c-1.243 0-1.864 0-2.354-.203a2.667 2.667 0 0 1-1.443-1.444c-.203-.49-.203-1.11-.203-2.353V7.333h1.333v3.334c0 .64.001 1.052.023 1.368.02.304.056.42.079.475.135.327.395.586.721.722.056.023.172.058.476.079.316.021.728.022 1.368.022Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconDownload24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDownload24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="m16.707 12.293-1.414-1.414L13 13.172V2h-2v11.172l-2.293-2.293-1.414 1.414L12 17l4.707-4.707Z"
                fill="currentColor"
            />
            <path
                d="M8 20h8c.96 0 1.578-.001 2.052-.033.457-.031.63-.085.713-.12a2 2 0 0 0 1.083-1.082c.034-.083.088-.256.119-.713.032-.474.033-1.093.033-2.052v-5h2v5c0 1.864 0 2.796-.305 3.53a4 4 0 0 1-2.164 2.165C18.796 22 17.864 22 16 22H8c-1.864 0-2.796 0-3.53-.305a4 4 0 0 1-2.166-2.164C2 18.796 2 17.864 2 16v-5h2v5c0 .96.001 1.578.033 2.052.032.457.085.63.12.713a2 2 0 0 0 1.082 1.083c.083.034.257.088.713.119C6.42 19.999 7.04 20 8 20Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconDownload = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDownload(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '12':
            return <IconDownload12 {...iconProps} />;
        case '16':
            return <IconDownload16 {...iconProps} />;
        case '24':
            return <IconDownload24 {...iconProps} />;
        default:
            return <IconDownload24 {...iconProps} />;
    }
});
